import { useState } from 'react';

import { Button } from '@/components/common/Button';
import { Input } from '@/components/common/Input';
import { FormField, Modal } from '@/components/common/Modal';
import { send } from '@/api/send';
import { useAppStore } from '@/store/app';
import { currencyToAmount, DEFAULT_CURRENCY } from '@/utils/format';

/** Port of `modals/CreateLocalAccountModal.tsx` (local account only). */
export function CreateAccountModal({ onClose }: { onClose: () => void }) {
  const [name, setName] = useState('');
  const [balance, setBalance] = useState('0.00');
  const [offbudget, setOffbudget] = useState(false);
  const [saving, setSaving] = useState(false);
  const refreshAccounts = useAppStore(state => state.refreshAccounts);

  async function submit() {
    if (!name.trim()) return;
    setSaving(true);
    await send('account-create', {
      name: name.trim(),
      offbudget: offbudget ? 1 : 0,
      starting_balance: currencyToAmount(balance, DEFAULT_CURRENCY) ?? 0,
    });
    await refreshAccounts();
    setSaving(false);
    onClose();
  }

  return (
    <Modal
      title="添加账户"
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose}>取消</Button>
          <Button
            variant="primary"
            disabled={!name.trim() || saving}
            onClick={() => void submit()}
            data-testid="account-modal-submit"
          >
            {saving ? '添加中…' : '添加账户'}
          </Button>
        </>
      }
    >
      <FormField label="账户名称">
        <Input
          autoFocus
          value={name}
          placeholder="招商银行卡"
          onChange={event => setName(event.target.value)}
          onKeyDown={event => {
            if (event.key === 'Enter') void submit();
          }}
        />
      </FormField>
      <FormField label="期初余额" hint="全新账户保持 0.00 即可。">
        <Input
          value={balance}
          inputMode="decimal"
          className="tnum text-right"
          onChange={event => setBalance(event.target.value)}
        />
      </FormField>
      <label className="flex cursor-pointer items-center gap-2 text-sm text-page-text">
        <input
          type="checkbox"
          checked={offbudget}
          onChange={event => setOffbudget(event.target.checked)}
          className="h-3.5 w-3.5 accent-[var(--color-checkboxBackgroundSelected)]"
        />
        该账户不计入预算
      </label>
    </Modal>
  );
}
